// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let TipBoxes = require("../../../reason/clients/components/TipBoxes.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Form__Checkbox = require("../../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
let QuestionPopover = require("../../../components/MyClientsWidget/components/QuestionPopover/QuestionPopover.bs.js");
let WizardFormUtils = require("../wizard/WizardFormUtils.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormUtils = require("./PropertyWizardFormUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardRelayKeyFactsPrice_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPrice_draft_graphql.bs.js");
let PropertyWizardRelay__KeyFacts__Price__ExactPrice = require("./PropertyWizardRelay__KeyFacts__Price__ExactPrice.bs.js");
let PropertyWizardRelay__KeyFacts__Price__PriceRange = require("./PropertyWizardRelay__KeyFacts__Price__PriceRange.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__Price = require("./PropertyWizardFormRelay__Validators__KeyFacts__Price.bs.js");

let convertFragment = PropertyWizardRelayKeyFactsPrice_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPrice_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPrice_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPrice_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPrice_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPrice_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPrice_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__Price(props) {
  let stepHasBeenTouched = props.stepHasBeenTouched;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPrice_draft_graphql.node, convertFragment, props.draft);
  let update = PropertyWizardFormRelay.useUpdateDraftProperty();
  let match = draft.draftProperty;
  let priceRange = match.priceRange;
  let commission = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.commission = value;
      return newrecord;
    }
  }, stepHasBeenTouched, match.commission, undefined);
  let price = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.price = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draft.draftProperty.price, PropertyWizardFormRelay__Validators__KeyFacts__Price.ExactPrice.useIsValid(draft.fragmentRefs));
  let minPrice = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.minPrice = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draft.draftProperty.minPrice, PropertyWizardFormRelay__Validators__KeyFacts__Price.MinPrice.useIsValid(draft.fragmentRefs));
  let maxPrice = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.maxPrice = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draft.draftProperty.maxPrice, PropertyWizardFormRelay__Validators__KeyFacts__Price.MaxPrice.useIsValid(draft.fragmentRefs));
  let minPriceOrMaxPriceFocused = minPrice.focused || maxPrice.focused;
  let match$1 = price.focused;
  let match$2 = draft.draftProperty.propertyType;
  let tmp;
  tmp = match$2 === "FOR_SALE" ? JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
      width: 12,
      widthMd: 6,
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Form__Label.make, {
                  labelText: "Concessions seller will consider",
                  optionalText: "Optional",
                  htmlFor: "concessions"
                }),
                JsxRuntime.jsx(QuestionPopover.make, {
                  children: "Not binding on the seller unless confirmed by separate agreement among applicable parties."
                })
              ],
              className: "flex gap-2 items-start"
            }),
            JsxRuntime.jsx(Form__Input.make, {
              onChange: event => {
                let text = event.currentTarget.value;
                commission.onChange(WizardFormUtils.noneIfEmpty(text));
              },
              onBlur: param => commission.onBlur(),
              status: commission.status,
              value: commission.valueAsString,
              id: "concessions"
            })
          ]
        }),
        JsxRuntime.jsx(Form__Components.FieldError.make, {
          valid: commission.valid
        })
      ]
    }) : null;
  return JsxRuntime.jsx(FormV5.FormSection.make, {
    tipbox: match$1 ? TipBoxes.PropertyWizard.price : (
        minPriceOrMaxPriceFocused ? TipBoxes.PropertyWizard.priceRange : undefined
      ),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
          children: [
            priceRange ? JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__Price__PriceRange.make, {
                draft: draft.fragmentRefs,
                minPrice: minPrice,
                maxPrice: maxPrice
              }) : JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__Price__ExactPrice.make, {
                draft: draft.fragmentRefs,
                price: price
              }),
            JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
              width: 12,
              children: JsxRuntime.jsx(ViewStack.make, {
                flexDirection: "column",
                children: JsxRuntime.jsx(Form__Checkbox.make, {
                  onChange: _e => update(c => {
                    let newrecord = {...c};
                    newrecord.priceRange = !priceRange;
                    return newrecord;
                  }),
                  name: "priceRange",
                  checked: priceRange,
                  label: "Or enter a price range instead"
                })
              })
            })
          ]
        }),
        JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
          children: tmp
        })
      ],
      className: "space-y-10"
    })
  });
}

let Components;

let FormSection;

let Checkbox;

let Grid;

let Cell;

let TextInputField;

let TipBoxes$1;

let ExactPrice;

let PriceRange;

let Validators;

let FormUtils;

let FormControl;

let make = PropertyWizardRelay__KeyFacts__Price;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Checkbox = Checkbox;
exports.Grid = Grid;
exports.Cell = Cell;
exports.TextInputField = TextInputField;
exports.TipBoxes = TipBoxes$1;
exports.ExactPrice = ExactPrice;
exports.PriceRange = PriceRange;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.FormControl = FormControl;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* FormV5 Not a pure module */
